import { apiClient } from "@api/client";
import { requestVoid } from "@api/request";

/** TODO(BE-1951): TEMPORARY — first-clinic launch only; delete with src/complaints/. */

export const complaintsClient = {
  file: (message: string): Promise<void> =>
    requestVoid(() => apiClient.POST("/complaints", { body: { message } })),
};
